export default "/plus.38b50c1c6912bd9490aaca52d937df3c.svg";